import { createActionType } from '../core';
import { NAME } from './constants';

export const REMOVE_CUSTOMER_DATA = createActionType(`${NAME}/REMOVE_CUSTOMER_DATA`);
export const CLEAR_REMOVED_CUSTOMERS_DATA = createActionType(`${NAME}/CLEAR_REMOVED_CUSTOMERS_DATA`);

export const CREATE_NEW_EMAIL = createActionType(`${NAME}/CREATE_NEW_EMAIL`);